 
namespace TabAurous.Sales {
    import fld = MaterialOutBOMRow.Fields; 
    @Serenity.Decorators.registerClass()
    export class MaterialOutBOMEditor extends _Ext.BOMGridEditor<MaterialOutBOMRow> { 
        protected getDialogType() { return MaterialOutBOMDialog; }
        protected getLocalTextPrefix() { return MaterialOutBOMRow.localTextPrefix; } 
        constructor(container: JQuery) {
            super(container);

            this.slickContainer.on('change', '.edit:input', (e) => this.inputsChange(e));
            this.slickGrid.setOptions({ rowHeight: 30 });
            this.view.onDataChanged.subscribe(() => {
                if (this.view.getItems().length > 0) {
                    (this.parentDialog as MaterialOutItemsDialog).CalculateTotals();
                }
            });
        } 

        protected getColumns() {

            var columns = super.getColumns();
            var amt = ctx => ColumnFormatter.AmountFormatter(ctx, this);
            Q.first(columns, x => x.field === fld.BomRate).format = amt;
            return columns;
        }  
    }
}